var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "mt-2" }, [
      _vm._v(_vm._s(_vm.$filters.capitalize(_vm.$l10n.__("paiement"))))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-6" },
      [
        _c("line-2-slots", {
          staticClass: "fs-3 mb-2",
          attrs: { isTitle: true },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function() {
                return [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.capitalize(
                          _vm.$l10n.__("votre abonnement")
                        )
                      ) +
                      "\n            "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "right",
              fn: function() {
                return [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.formatAmount(
                          _vm.centsToCurrency(_vm.cart.totalAmountPerMonth)
                        )
                      ) +
                      " /\n                " +
                      _vm._s(_vm.$l10n.__("mois")) +
                      "\n            "
                  )
                ]
              },
              proxy: true
            }
          ])
        }),
        _vm._v(" "),
        _vm.cartBasicProduct.customPricing &&
        _vm.cartBasicProduct.customPricing.length
          ? _vm._l(_vm.cartBasicProduct.customPricing.reverse(), function(
              pricing,
              index
            ) {
              return _c("line-2-slots", {
                key: index,
                staticClass: "fs-3 mb-2",
                scopedSlots: _vm._u(
                  [
                    pricing.unit_amount === 0
                      ? {
                          key: "left",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%(nb)s utilisateur",
                                      "%(nb)s utilisateurs",
                                      pricing.nbLicences,
                                      { nb: pricing.nbLicences }
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          },
                          proxy: true
                        }
                      : {
                          key: "left",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%(nb)s utilisateur",
                                      "%(nb)s utilisateurs",
                                      pricing.nbLicences,
                                      { nb: pricing.nbLicences }
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          },
                          proxy: true
                        },
                    pricing.unit_amount === 0
                      ? {
                          key: "right",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "Offert",
                                      "Offerts",
                                      pricing.nbLicences
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          },
                          proxy: true
                        }
                      : {
                          key: "right",
                          fn: function() {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.getPricingByPlan(pricing.unit_amount)
                                    )
                                  ) +
                                  " /\n                    " +
                                  _vm._s(_vm.$l10n.__("mois")) +
                                  "\n                "
                              )
                            ]
                          },
                          proxy: true
                        }
                  ],
                  null,
                  true
                )
              })
            })
          : _c("line-2-slots", {
              staticClass: "fs-3 mb-2",
              scopedSlots: _vm._u(
                [
                  _vm.licenses.offered > 0
                    ? {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%(nb)s utilisateur",
                                    "%(nb)s utilisateurs",
                                    _vm.licenses.nb,
                                    {
                                      nb: _vm.licenses.nb
                                    }
                                  )
                                ) +
                                "\n                " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "dont %(offered)s offert",
                                    "dont %(offered)s offerts",
                                    _vm.licenses.offered,
                                    { offered: _vm.licenses.offered }
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    : {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%(nb)s utilisateur",
                                    "%(nb)s utilisateurs",
                                    _vm.licenses.nb,
                                    {
                                      nb: _vm.licenses.nb
                                    }
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                  {
                    key: "right",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.formatAmount(
                                _vm.cartBasicProductTotalAmountPerMonth
                              )
                            ) +
                            " / " +
                            _vm._s(_vm.$l10n.__("mois")) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            }),
        _vm._v(" "),
        _vm._l(_vm.cart.items, function(product) {
          return _c("line-2-slots", {
            key: product.id,
            staticClass: "fs-3 mb-2",
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.productName(product)) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "right",
                  fn: function() {
                    return [
                      product == _vm.cartBasicProduct
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.capitalize(_vm.$l10n.__("inclus"))
                              )
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatAmount(
                                  _vm.centsToCurrency(
                                    product.totalAmountPerMonth
                                  )
                                )
                              ) +
                                " /\n                    " +
                                _vm._s(_vm.$l10n.__("mois"))
                            )
                          ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-6 py-4 bt-1 bb-1 fs-3" },
      [
        _vm.isCartContext("new")
          ? _c("line-2-slots", {
              attrs: { isSubtitle: true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "left",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__("date d'activation")
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "right",
                    fn: function() {
                      return [
                        _vm.cartPeriodStartDateObj
                          ? _c("span", { staticClass: "red" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      _vm.cartPeriodStartDateObj.unix(),
                                      "NORMAL_DATE",
                                      false
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                          : _c("span", { staticClass: "red" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$filters.dateFormatter(
                                      _vm.now.unix(),
                                      "NORMAL_DATE",
                                      false
                                    )
                                  ) +
                                  "\n                "
                              )
                            ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1300397006
              )
            })
          : (_vm.isCartContext("legacy_renew") || _vm.isCartContext("renew")) &&
            _vm.cartPeriodStartDateObj
          ? _c("line-2-slots", {
              attrs: { isSubtitle: true },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Date de renouvellement de votre abonnement"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "right",
                  fn: function() {
                    return [
                      !_vm.cartEarlyRenewal
                        ? _c("span", { staticClass: "red" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$filters.dateFormatter(
                                    _vm.cartPeriodStartDateObj.unix(),
                                    "NORMAL_DATE",
                                    false
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        : _c("span", { staticClass: "red" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$filters.dateFormatter(
                                    _vm.now.unix(),
                                    "NORMAL_DATE",
                                    false
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          : !_vm.isCartContext("new") && _vm.customerServiceEndDate
          ? _c("line-2-slots", {
              attrs: { isSubtitle: true },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__("Date de fin de votre abonnement")
                          ) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "right",
                  fn: function() {
                    return [
                      _c("span", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$filters.dateFormatter(
                                _vm.customerServiceEndDateObj.unix(),
                                "NORMAL_DATE",
                                false
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isCartContext("renew")
          ? _c("line-2-slots", {
              scopedSlots: _vm._u(
                [
                  _vm.cart.paymentMethod == "stripe_card"
                    ? {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__(
                                      "la facture sera éditée et prélevée le %(date)s",
                                      {
                                        date: _vm.$filters.dateFormatter(
                                          _vm.cartInvoiceEditionDate.unix(),
                                          "SLASHED_DATE",
                                          false
                                        )
                                      }
                                    )
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    : {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__(
                                      "la facture sera éditée le %(date)s",
                                      {
                                        date: _vm.$filters.dateFormatter(
                                          _vm.cartInvoiceEditionDate.unix(),
                                          "SLASHED_DATE",
                                          false
                                        )
                                      }
                                    )
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                ],
                null,
                true
              )
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.isMonthly
      ? _c(
          "div",
          { staticClass: "mt-6" },
          [
            _c("line-2-slots", {
              staticClass: "fs-3 mb-2",
              attrs: { isTitle: true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "left",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__("total mensuel")
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "right",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.formatAmount(
                                _vm.cartTotalAmountPerMonth,
                                true
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                366577716
              )
            }),
            _vm._v(" "),
            _vm.showTaxTotal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(_vm.$l10n.__("TVA"))
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountVatPerMonth,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3953669215
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showTaxTotal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("Total mensuel TTC")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountVatIncludedPerMonth,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3817671820
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.cartEarlyRenewal
              ? _c("line-2-slots", {
                  staticClass: "bt-1 pt-3 fs-3 mt-6 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("échéancier")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3470590966
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.cartEarlyRenewal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("Restant à consommer")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    -1 *
                                      _vm.centsToCurrency(
                                        _vm.cartEarlyRenewalDiscount
                                      ),
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2852189592
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.deadlines, function(deadline) {
              return _c("line-2-slots", {
                key: deadline.key,
                staticClass: "fs-3 mb-2",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$filters.dateFormatter(
                                  deadline.date.unix(),
                                  "NORMAL_DATE",
                                  false
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.formatAmount(deadline.amount, true)) +
                              "\n            "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            _vm._v(" "),
            _vm.deadlineUnchanged > 0 && _vm.deadlineUnchanged < 12
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "%(deadlineUnchanged)s échéances suivantes",
                                    {
                                      deadlineUnchanged: _vm.deadlineUnchanged
                                    }
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountVatIncludedPerMonth,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2903903605
                  )
                })
              : _vm._e()
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "mt-6" },
          [
            _vm.cartEarlyRenewal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("Montant HT")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountPerYear,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1373519359
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.cartEarlyRenewal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("Restant à consommer")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    -1 *
                                      _vm.centsToCurrency(
                                        _vm.cartEarlyRenewalDiscount
                                      ),
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2852189592
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c("line-2-slots", {
              staticClass: "fs-3 mb-2",
              attrs: { isTitle: true },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.capitalize(_vm.$l10n.__("total"))
                          ) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "right",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.totalPreviewCart.perYearDiscounted,
                              true
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _vm.showTaxTotal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$l10n.__("TVA")) +
                                " (" +
                                _vm._s(_vm.countryTaxRate * 100) +
                                "%) "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountVatPerYear,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    97647289
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showTaxTotal
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__("total TTC")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartTotalAmountVatIncludedPerYear,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    809623354
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isPaymentFacilityEnabled
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Paiement en %s fois activé",
                                    _vm.cart.paymentFacility
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      _vm.cartNextAmountFacility < _vm.cartFirstAmountFacility
                        ? {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                1 x " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.cartFirstAmountFacility,
                                        true
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            },
                            proxy: true
                          }
                        : {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.cart.paymentFacility) +
                                    " x " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.cartFirstAmountFacility,
                                        true
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            },
                            proxy: true
                          }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isPaymentFacilityEnabled &&
            _vm.cartNextAmountFacility < _vm.cartFirstAmountFacility
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.cart.paymentFacility - 1) +
                                " x\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartNextAmountFacility,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1615723584
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isCustomPaymentFacilityEnabled
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Paiement en %s fois activé",
                                    _vm.cartNbCustomFacilities
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      _vm.cartNextAmountFacility < _vm.cartFirstAmountFacility
                        ? {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.cartNbFirstCustomFacilities) +
                                    " x\n                " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.cartFirstAmountCustomFacility,
                                        true
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            },
                            proxy: true
                          }
                        : {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.cartNbCustomFacilities) +
                                    " x " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.cartFirstAmountFacility,
                                        true
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            },
                            proxy: true
                          }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isCustomPaymentFacilityEnabled &&
            _vm.cartFirstAmountCustomFacility < _vm.cartLastAmountCustomFacility
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                1 x " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.cartLastAmountCustomFacility,
                                    true
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1748085017
                  )
                })
              : _vm._e()
          ],
          1
        ),
    _vm._v(" "),
    _vm.isCartContext("upsale")
      ? _c(
          "div",
          { staticClass: "mt-6" },
          [
            _c("line-2-slots", {
              staticClass: "fs-3 mb-2",
              attrs: { isTitle: true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "left",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__(
                                  "total HT supplémentaire estimé à payer*"
                                )
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "right",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.formatAmount(
                                _vm
                                  .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                  .totalDiscounted
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3612146685
              )
            }),
            _vm._v(" "),
            _vm.showTaxTotal && _vm.countryTaxRate > 0
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$l10n.__("TVA estimée")) +
                                " (" +
                                _vm._s(_vm.countryTaxRate * 100) +
                                "%)\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm
                                      .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                      .tax
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    252332184
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showTaxTotal && _vm.countryTaxRate > 0
              ? _c("line-2-slots", {
                  staticClass: "fs-3 mb-2",
                  attrs: { isSubtitle: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__(
                                      "total TTC supplémentaire estimé à payer*"
                                    )
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "right",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm
                                      .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                      .totalTaxIncluded
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3252158539
                  )
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isCartContext("upsale")
      ? _c("div", { staticClass: "my-5" }, [
          _vm.isCurrentPricingMonthly
            ? _c("p", [
                _c("span", { staticClass: "semibold" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Attention")) + " :")
                ]),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "La prochaine facture est calculée prorata temporis, les échéances suivantes au taux plein"
                      )
                    ) +
                    ".\n        "
                )
              ])
            : _c("p", { staticClass: "my-5" }, [
                _vm._v(
                  "\n            *\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Ce montant est une estimation pour un prorata à cet instant. Le montant exact de la facture sera calculé au prorata du temps restant sur votre abonnement au moment du paiement."
                      )
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.hasManualPaymentMethod
      ? _c(
          "div",
          { staticClass: "mt-6" },
          [
            _c("CompassButton", {
              staticClass: "wp-10",
              attrs: {
                label: _vm.isCartContext("renew")
                  ? _vm.$l10n.__("valider mon renouvellement")
                  : _vm.$filters.capitalize(
                      _vm.$l10n.__("valider et payer mon abonnement")
                    ),
                type: "primary",
                disabled: !_vm.clickEnabled
              },
              on: {
                click: function($event) {
                  return _vm.$emit("clicked")
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mt-8 b-1 p-4 br" }, [
      _c("p", { staticClass: "fs-3 m-0" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$l10n.__(
                "Vous pouvez partager cette page avec le lien suivant"
              )
            ) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-2 mb-0 copy-element block" },
        [
          _c("a", { staticClass: "link" }, [_vm._v(_vm._s(_vm.currentUrl))]),
          _vm._v(" "),
          _vm.currentUrl
            ? _c("SaasClipboard", { attrs: { data: _vm.currentUrl } })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }